<lib-layout [hasReadPermission]="hasReadPermission" [logoUrl]="logoUrl" [groupMenus]="groupMenus"
  [email]="email" (signOut)="onLogout($event)" title="Campaigns" [signedIn]="authService.isLoggedIn | async">
  <router-outlet />
</lib-layout>